import PropTypes from 'prop-types';
import React, { useState } from 'react';
import './style.css';
import { Tag } from '../../components/Tag';

export const CardsCategories = ({ element }) => {
    const [showAll, setShowAll] = useState(false);

    const handleToggleShowAll = () => {
        setShowAll(!showAll);
    };

    const getAllTags = () => {
        const mediaUsageGoal = [element.mediaUsageGoal] || [];
        const subjectMatterTags = element.subjectMatterCategories || [];
        const schoolTypeTags = element.schoolTypes || [];
        return [...mediaUsageGoal, ...subjectMatterTags, ...schoolTypeTags];
    };

    const renderTags = () => {
        const allTags = getAllTags();

        const visibleTags =
            showAll || allTags.length <= 2 ? allTags : allTags.slice(0, 2);
        return visibleTags.map((tag, index) => (
            <Tag
                key={index}
                className="tag-instance"
                size="small"
                stateProp="default"
                style="default"
                text={tag.goal || tag.category || tag.name}
                isClickable={false}
            />
        ));
    };

    const allTagsCount =
        (element.mediaUsageGoal?.length || 0) +
        (element.subjectMatterCategories?.length || 0) +
        (element.schoolTypes?.length || 0);

    return (
        <div className="categories">
            {renderTags()}
            {allTagsCount > 2 && (
                <button className="button_tag" onClick={handleToggleShowAll}>
                    {showAll ? 'Less' : 'More'}
                </button>
            )}
        </div>
    );
};

CardsCategories.propTypes = {
    element: PropTypes.object,
};
